import {useEffect, useState} from "react";
import {useAppDispatch} from "../../redux/store";
import {changeSidebarInOrders, changeSidebarWithNavigate} from "../../redux/slices/sidebar.slice";
import {changeActionbarType} from "../../redux/slices/actionbar.slice";
import {ActionbarType} from "../../redux/reducers/actionbar-reducers";

const ProhibitedItems = () => {
    const [isReady, setIsReady] = useState<boolean>(false);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isReady) {
            dispatch(changeSidebarInOrders(false));
            dispatch(changeSidebarWithNavigate(true));
            dispatch(changeActionbarType(ActionbarType.CALCULATE));

            setIsReady(true);
        }
    }, [])

    return (
        <>

        </>
    );
};

export default ProhibitedItems;
